import { ca } from '@cian/analytics';

type TDetailsLabel = 'detailedRent' | 'detailedDailyRent' | 'detailedSellToBuy' | 'detailedSellToDeposit';
type TButtonLabel = 'goRent' | 'goDailyRent' | 'goSellToBuy' | 'goSellToDeposit';

export const trackDetailsClick = (label: TDetailsLabel) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHome',
    action: 'Click',
    label,
  });
};

export const trackButtonClick = (label: TButtonLabel) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHome',
    action: 'Click',
    label,
  });
};

export const trackShowHelpModal = (label: 'SellWCianPopup' | 'RentWCianPopup') => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHome',
    action: 'Show',
    label,
  });
};

export const trackCloseHelpModal = (label: 'CloseSellWCianPopup' | 'CloseRentWCianPopup') => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHome',
    action: 'Click',
    label,
  });
};

export const trackAgentFormClick = (label: 'SellWAgentPopup' | 'RentWAgentPopup') => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHome',
    action: 'Click',
    label,
  });
};

export const trackNewOfferClick = (label: 'SellMyselfPopup' | 'RentMyselfPopup') => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHome',
    action: 'Click',
    label,
  });
};
